import React from 'react';
import { Box, IconButton, Typography, Paper } from '@mui/material';
import { DeleteOutline, EditOutlined } from '@mui/icons-material';
import { OOOInitialValues } from '../OutOfOfficeModal/UpdateOutOfOfficeModal.component';

export type OutOfOfficeEventRowProps = {
  event: OOOInitialValues & { id: string };
  onEdit: (event: OOOInitialValues) => void;
  onDelete: (id: string) => void;
};

export const OutOfOfficeEventRow: React.FC<OutOfOfficeEventRowProps> = ({ event, onEdit, onDelete }) => (
  <Box
    sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 1, p: 1.5 }}
    component={Paper}
    variant="outlined"
  >
    <Box>
      <Typography fontWeight={600}>{event.title}</Typography>
      <Typography variant="caption" >
        {event.startDate.format('MMM D')} - {event.endDate.format('MMM D, YYYY')}
      </Typography>
    </Box>
    <Box display="flex" gap={0.5}>
      <IconButton size="small" onClick={() => onEdit(event)}>
        <EditOutlined fontSize="small" />
      </IconButton>
      <IconButton size="small" onClick={() => onDelete(event.id)} sx={{ color: 'error.main' }}>
        <DeleteOutline fontSize="small" />
      </IconButton>
    </Box>
  </Box>
);
